// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1o3Xd","buttons":"SendReceipts_buttons__7OBW9","email":"SendReceipts_email__23Zk0","bookApptTitle":"SendReceipts_bookApptTitle__1JRAB"};